module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('breadcrumb-bar', {
    attrs: {
      "crumbs": ['Manage Users']
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "portlet light"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "tab-content marginTop"
  }, [_c('div', {
    staticClass: "tab-pane active",
    attrs: {
      "id": "update-access"
    }
  }, [_c('manage-users-form')], 1)])])])]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  })], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "portlet-title tabbable-line"
  }, [_c('div', {
    staticClass: "caption caption-md"
  }, [_c('i', {
    staticClass: "icon-globe theme-font hide"
  }), _vm._v(" "), _c('span', {
    staticClass: "caption-subject bold uppercase"
  }, [_vm._v("MANAGE USERS")])]), _vm._v(" "), _c('ul', {
    staticClass: "nav nav-tabs"
  }, [_c('li', {
    staticClass: "active"
  }, [_c('a', {
    attrs: {
      "href": "#update-access",
      "data-toggle": "tab",
      "aria-expanded": "false"
    }
  }, [_vm._v("Manage Users")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-060c0b4e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/ManageUsers.vue
// module id = 1540
// module chunks = 1